import { AaasFreeTrialEndedModal_14Days_AccountSubscription_NoFreePlan } from './AaasFreeTrialEnded/AaasFreeTrialEndedModal';
import { AaasSubscriptionEndedModal_AccountSubscription_NoFreePlan } from './AaaSubscriptionEnded/AaasSubscriptionEndedModal';
import AnnouncementModal from './AnnouncementModal';
import FeatureLimitReached from './FeatureLimitReached';
import { AaasFreeTrialEndingModal, FreeTrialEndingModal } from './FreeTrialEndingModal';
import ManualScreenshotContainer from './ManualScreenshot';
import { PricingPlanSuggestionModal } from './PricingPlanSuggestionModal';
import SignDPA from './SignDPA';
import SsrReachedLimit from './SsrReachedLimit';
import SsrTechnicalLimitation from './SsrTechnicalLimitation/SsrTechnicalLimitation';
import TabInformation from './TabInformation';
import VideoOverlay from './VideoOverlay';
import VisitsLimitReached from './VisitsLimitReached';

const Modals = {
  AnnouncementModal,
  SignDPA,
  SsrReachedLimit,
  SsrTechnicalLimitation,
  VisitsLimitReached,
  VideoOverlay,
  FeatureLimitReached,
  TabInformation,
  ManualScreenshotContainer,
  FreeTrialEndingModal,
  AaasFreeTrialEndingModal,
  AaasFreeTrialEndedModal_14Days_AccountSubscription_NoFreePlan,
  AaasSubscriptionEndedModal_AccountSubscription_NoFreePlan,
};

export { PricingPlanSuggestionModal };
export default Modals;
